import * as React from 'react';

export const useApolloErrorWrapper = () => {
  const [error, setError] = React.useState<Error | undefined>(undefined);

  const clearError = React.useCallback(() => {
    setError(undefined);
  }, [setError]);

  const onError = React.useCallback(
    (error: Error) => {
      setError(error);
    },
    [setError]
  );

  return { onError, clearError, error };
};
